<!--媒体认证-->
<template>
  <div class="media-authentication-container">
    <div class="media-authentication-content">
      <p class="tips">适用于新闻媒体机构等</p>
      <p class="small-title">机构信息</p>
      <el-form ref="mediaForm0" :model="mediaForm" :rules="mediaRules" label-width="125px" style="width: 50%"
               label-position="left">
        <el-form-item label="机构名称：" prop="institutionName">
          <el-input v-model="mediaForm.institutionName"/>
        </el-form-item>
        <el-form-item label="社会信用代码：" prop="creditCode">
          <el-input v-model="mediaForm.creditCode"/>
        </el-form-item>
        <el-form :model="mediaForm" :rules="mediaRules" ref="mediaForm1" label-position="top">
          <el-form-item>
            <span slot="label"><span style="color: #FE273B">*</span>数字工商证书<span class="gary-tips"> 仅限平台使用</span></span>
            <div class="upload-image">
              <div class="certificate" @click="showCertificate"/>
              <div class="el-upload__tip" v-if="!corporateInfo.code">数字工商证书自动生成失败，请
                <el-link class="el-active" :underline="false" type="primary" @click="dialogVisible2=true">手动上传</el-link>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="proofUrl">
            <span slot="label">互联网新闻信息服务许可证：<span class="gary-tips"> 仅限平台使用</span></span>
            <div class="upload-image">
              <el-upload class="avatar-uploader" action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg"
                         :on-success="successUpload4" :show-file-list="false">
                <el-image v-if="mediaForm.proofUrl" :src="mediaForm.proofUrl" fit="cover"
                          style="width: 100px;height: 100px;border-radius: 6px;"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="修改头像">
            <div class="upload-avatar">
              <el-upload class="avatar-uploader"
                         action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg"
                         :on-success="successUpload2" :show-file-list="false">
                <el-avatar v-if="mediaForm.avatar" :size="100" :src="mediaForm.avatar" fit="cover"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <el-form-item label="所在地区：" prop="address">
          <el-cascader v-model="mediaForm.address" placeholder="" :options="areaInfo"
                       :props="{ expandTrigger: 'hover' }" clearable separator="-"/>
        </el-form-item>
        <el-form :model="mediaForm" :rules="mediaRules" ref="mediaForm2" label-position="top">
          <el-form-item label="上传法人身份证">
            <div style="display: flex;text-align: center;" class="upload-image">
              <el-upload class="avatar-uploader"
                         action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg"
                         style="margin-right: 20px" :on-success="successUpload" :show-file-list="false">
                <el-image v-if="mediaForm.identityimgFront" :src="mediaForm.identityimgFront" fit="cover"
                          style="width: 100px;height: 100px;border-radius: 6px;"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__tip" slot="tip">身份证正面</div>
              </el-upload>
              <el-upload class="avatar-uploader"
                         action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg"
                         :on-success="successUpload3" :show-file-list="false">
                <el-image v-if="mediaForm.identityimgBack" :src="mediaForm.identityimgBack" fit="cover"
                          style="width: 100px;height: 100px;border-radius: 6px;"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__tip" slot="tip">身份证反面</div>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <el-form-item label="联系电话：" prop="phone">
          <el-input v-model="mediaForm.phone"/>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="mediaForm.code" maxlength="6" placeholder="">
            <template slot="suffix">
              <el-link style="color: #1637FF;font-size: 14px;" @click="getCode" :underline="false"
                       v-show="flag">获取验证码
              </el-link>
              <el-link disabled v-show="!flag">{{ second + 's后重试' }}</el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="开通云官网：">
          <el-switch v-model="mediaForm.chooseMicroWebsite" active-color="#1637FF"
                     :active-value="1" :inactive-value="0" inactive-color="#EEEEEE"/>
        </el-form-item>
        <el-form-item prop="isRead" label-width="0px">
          <el-checkbox v-model="mediaForm.isRead">我已阅读并同意
            <el-link class="el-active" :underline="false" @click="privacyPolicy">《隐私政策》</el-link>
          </el-checkbox>
        </el-form-item>
        <el-form-item label-width="0px">
          <el-button @click="submitForm"
                     :disabled="mediaForm.chooseMicroWebsite==1 && mediaForm.isRead ? false : true"
                     type="danger">提交审核
          </el-button>
        </el-form-item>
      </el-form>
      <el-dialog title="数字工商证书" :visible.sync="dialogVisible" width="790.02px" top="0px" class="media-dialog"
                 :modal="false">
        <div class="certificate-dialog">
          <div class="dialog-content">
            <el-row class="dialog-row">
              <el-col :span="6">企业名称:</el-col>
              <el-col :span="15">
                {{ corporateInfo.companyName || '-' }}
              </el-col>
            </el-row>
            <el-row class="dialog-row">
              <el-col :span="6">企业类型:</el-col>
              <el-col :span="15">
                {{ corporateInfo.companyType || '-' }}
              </el-col>
            </el-row>
            <el-row class="dialog-row">
              <el-col :span="6">统一社会信用代码:</el-col>
              <el-col :span="15">
                {{ corporateInfo.code || '-' }}
              </el-col>
            </el-row>
            <el-row class="dialog-row">
              <el-col :span="6">经营地址:</el-col>
              <el-col :span="15">
                {{ corporateInfo.address || '-' }}
              </el-col>
            </el-row>
            <el-row class="dialog-row">
              <el-col :span="6">法定代表人:</el-col>
              <el-col :span="15">
                {{ corporateInfo.fname || '-' }}
              </el-col>
            </el-row>
            <el-row class="dialog-row">
              <el-col :span="6">注册资本:</el-col>
              <el-col :span="15">
                {{ corporateInfo.registeredCapital || '-' }}
              </el-col>
            </el-row>
            <el-row class="dialog-row">
              <el-col :span="6">成立时间:</el-col>
              <el-col :span="15">
                {{ corporateInfo.creatTime  || '-'}}
              </el-col>
            </el-row>
            <el-row class="dialog-row">
              <el-col :span="6">营业期限:</el-col>
              <el-col :span="15">
                {{ corporateInfo.businessTerm || '-'}}
              </el-col>
            </el-row>
          </div>
        </div>
      </el-dialog>
      <el-dialog title="补充信息" :visible.sync="dialogVisible2" width="790.02px" custom-class="supplementInfo"
                 :modal="false">
        <el-form ref="corporate0" :model="corporateInfo" :rules="corporateRules" label-position="left">
          <el-form-item label="企业名称：" prop="companyName" label-width="95px">
            <el-input v-model="corporateInfo.companyName" clearable/>
          </el-form-item>
          <el-form :inline="true" :model="corporateInfo" :rules="corporateRules" class="demo-form-inline"
                   ref="corporate1">
            <el-form-item label="企业类型：" prop="companyType" label-width="95px">
              <el-select v-model="corporateInfo.companyType" placeholder="" clearable>
                <el-option v-for="list in businessType" :label="list.name" :value="list.name"/>
              </el-select>
            </el-form-item>
            <el-form-item label="统一社会信用代码：" prop="code" label-width="150px">
              <el-input v-model="corporateInfo.code" clearable/>
            </el-form-item>
          </el-form>
          <el-form-item label="经营地址：" prop="address" label-width="95px">
            <el-input v-model="corporateInfo.address" clearable/>
          </el-form-item>
          <el-form :inline="true" :model="corporateInfo" :rules="corporateRules" class="demo-form-inline"
                   ref="corporate2">
            <el-form-item label="注册资本：" prop="registeredCapital" label-width="95px">
              <el-input v-model="corporateInfo.registeredCapital" clearable>
                <i class="price-icon" slot="suffix">万元</i>
              </el-input>
            </el-form-item>
            <el-form-item label="法定代表人：" prop="fname">
              <el-input v-model="corporateInfo.fname" clearable/>
            </el-form-item>
          </el-form>
          <el-form :inline="true" :model="corporateInfo" :rules="corporateRules" class="demo-form-inline"
                   ref="corporate3">
            <el-form-item label="成立时间：" prop="creatTime" label-width="95px">
              <el-date-picker v-model="corporateInfo.creatTime" type="date" placeholder="" value-format="yyyy-MM-dd"
                              clearable/>
            </el-form-item>
            <el-form-item label="营业期限：" prop="businessTermEnd">
              <el-date-picker v-model="corporateInfo.businessTermEnd" type="date" placeholder="无固定期限"
                              value-format="yyyy-MM-dd"
                              clearable :picker-options="pickerOptions"/>
            </el-form-item>
          </el-form>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" @click="submitSupplementInfo">确定</el-button>
          <el-button @click="dialogVisible2=false">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import areaJson from '@/static/area.json';
import {sendsms,verifySms} from "@/api/currencyApi";
import {
  choiceOfBusinessType,
  verifyNameIsAuthenticated,
  verifyUSCCOdeIsAuthenticated,
  yqzdCompanyInfoBycode,
  reviewAuthenticationForEight
} from "@/api/systemSetting";

export default {
  name: "mediaAuthentication",
  data() {
    let that = this;
    /*验证企业/机构名称是否已被认证*/
    const checkCorporateName = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入机构名称'));
      } else {
        verifyNameIsAuthenticated({name: value, uid: that.userInfo.cid}).then(res => {
          if (res.code == 200) {
            callback();
          } else if (res.code == 202) {
            callback(new Error(res.content));
          }
        })
      }
    }
    /*校验社会信用代码*/
    const checkCreditCode = (rule, value, callback) => {
      let that = this;
      if (value == '') {
        that.corporateInfo = {
          address: '',
          area: '',
          businessScope: '',
          businessTerm: '',
          businessTermStart: '',
          businessTermEnd: '',
          cid: '',
          city: '',
          code: '',
          companyLogo: '',
          companyName: '',
          companyType: '',
          creatTime: '',
          fname: '',
          industryId: '',
          province: '',
          registeredCapital: '',
        }
        callback(new Error('请输入社会信用代码'));
      } else {
        /*验证企业/机构社会信用代码是否已被认证*/
        verifyUSCCOdeIsAuthenticated({code: value, uid: that.userInfo.cid}).then(res => {
          if (res.code == 200) {
            yqzdCompanyInfoBycode({code: value, request: 'form', uid: that.userInfo.cid}).then(res => {
              if (res.code == 200) {
                let reg = new RegExp(',', 'g')//g代表全部
                that.corporateInfo = res.content;
                if (res.content.businessTerm.indexOf(' 至 ') > -1) {
                  that.corporateInfo.businessTermEnd = (res.content.businessTerm.split(' 至 '))[1] == '无固定期限' ? '' : (res.content.businessTerm.split(' 至 '))[1];
                  that.corporateInfo.businessTermStart = (res.content.businessTerm.split(' 至 '))[0];
                } else {
                  that.corporateInfo.businessTermEnd = (res.content.businessTerm.split('至'))[1] == '无固定期限' ? '' : (res.content.businessTerm.split('至'))[1];
                  that.corporateInfo.businessTermStart = (res.content.businessTerm.split('至'))[0];
                }
                if (res.content.registeredCapital.indexOf('万(元)') > -1) {
                  that.corporateInfo.registeredCapital = ((res.content.registeredCapital.split('万(元)'))[0]).replace(reg, '');
                }
                // 定义一个方法查找对象
                function findBusinessType(row) {
                  return row.name === res.content.companyType;
                }
                if (!that.businessType.find(findBusinessType)) {
                  that.businessType.push({id: res.content.companyType, name: res.content.companyType})
                }
                that.mediaForm.address=[res.content.province,res.content.city,res.content.area];
                that.mediaForm.institutionName = res.content.companyName;
                that.mediaForm.creditCode = res.content.code;
              }
            })
            callback();
          } else if (res.code == 202) {
            callback(new Error(res.msg));
          }
        })
      }
    }
    /*验证身份证上传*/
    const uploadIdentityCard = (rule, value, callback) => {
      if (this.mediaForm.identityimgFront == '') {
        callback(new Error('请上传身份证正面'));
      } else if (this.mediaForm.identityimgBack == '') {
        callback(new Error('请上传身份证背面'));
      } else {
        callback();
      }
    }
    // 验证手机号
    const validatorPhone = function (rule, value, callback) {
      if (value === "")
        callback(new Error("手机号不能为空"));
      else if (!/^1\d{10}$/.test(value))
        callback(new Error("手机号格式错误"));
      else
        callback();
    }
    /*校验营业期限*/
    const checkBusinessTerm = (rule, value, callback) => {
      if (value == '') {
        callback();
      } else {
        callback();
      }
    }
    return {
      mediaForm:{
        institutionName: '',/*机构名称*/
        creditCode: '',/*社会信用代码*/
        address:'',/*所在地区*/
        avatar:'',/*机构头像*/
        identityimgFront: '',/*身份证人像面*/
        identityimgBack: '',/*身份证国徽面*/
        phone:'',/*联系电话*/
        code:'',/*验证码*/
        chooseMicroWebsite: 0,/*开通云官网选择状态（0：未选择，1：已选择）*/
        isRead: false,
        proofUrl:'',/*互联网新闻信息服务许可证*/
      },
      mediaRules:{
        institutionName: [
          {required: true, validator: checkCorporateName, trigger: 'blur'}
        ],
        creditCode: [
          {required: true, validator: checkCreditCode, trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请选择所在地区', trigger: 'change'}
        ],
        identityimgFront: [
          {required: true, validator: uploadIdentityCard, trigger: "change"}
        ],
        phone: [
          {required: true, validator: validatorPhone, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ],
        proofUrl:[
          { required: true, message: '请上传互联网新闻信息服务许可证', trigger: 'change' }
        ],
      },
      /*机构名称*/
      corporateInfo: {
        address: '',
        area: '',
        businessScope: '',
        businessTerm: '',
        businessTermStart: '',
        businessTermEnd: '',
        cid: '',
        city: '',
        code: '',
        companyLogo: '',
        companyName: '',
        companyType: '',
        creatTime: '',
        fname: '',
        industryId: '',
        province: '',
        registeredCapital: '',
      },
      enterpriseInfo:{},
      userInfo: {},
      dialogVisible: false,
      dialogVisible2: false,
      corporateRules: {
        companyName: [
          {required: true, validator: checkCorporateName, trigger: 'blur'}
        ],
        companyType: [
          {required: true, message: '请选择企业类型', trigger: 'change'}
        ],
        code: [
          {required: true, validator: checkCreditCode, trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请填写经营地址', trigger: 'blur'}
        ],
        registeredCapital: [
          {required: true, message: '请填写注册资本', trigger: 'blur'}
        ],
        fname: [
          {required: true, message: '请填写法定代表人', trigger: 'blur'}
        ],
        creatTime: [
          {required: true, message: '请选择成立时间', trigger: 'change'}
        ],
        businessTermEnd: [
          {required: true, validator: checkBusinessTerm, trigger: 'change'}
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(that.corporateInfo.creatTime).getTime();
        },
        shortcuts: [{
          text: '无固定期限', onClick(picker) {
            picker.$emit('pick', '')
          }
        }]
      },
      businessType: [],
      unSubmit: false,
      areaInfo: areaJson,
      flag: true,
      second: 300,
      timer: null, // 该变量是用来记录定时器的,防止点击的时候触发多个setInterval
    }
  },
  methods:{
    /*图片上传成功后处理-身份证正面*/
    successUpload(response, file, fileList) {
      this.mediaForm.identityimgFront = response.imgPath;
    },
    /*图片上传成功后处理-身份证反面*/
    successUpload3(response, file, fileList) {
      this.mediaForm.identityimgBack = response.imgPath;
    },
    /*图片上传成功后处理-修改头像*/
    successUpload2(response, file, fileList) {
      this.mediaForm.avatar = response.imgPath;
    },
    /*图片上传成功后处理-互联网新闻信息服务许可证*/
    successUpload4(response, file, fileList) {
      this.mediaForm.proofUrl = response.imgPath;
    },
    /*查看数字工商证书*/
    showCertificate() {
      if (this.corporateInfo.companyName) {
        if (this.unSubmit) {
          this.$message('请提交后查看。');
        } else {
          this.dialogVisible = true
        }
      } else {
        this.$message('请先申请数字证书。');
      }
    },
    /*获取企业类型*/
    getBusinessType() {
      choiceOfBusinessType().then(res => {
        if (res.code == 200) {
          this.businessType = res.content;
        }
      })
    },
    /*提交企业基本信息*/
    submitSupplementInfo() {
      let can = 0, that = this;
      for (let a = 0; a < 4; a++) {
        this.$refs['corporate' + a].validate((valid) => {
          if (valid) {
          } else {
            can++;
            return false;
          }
        });
      }
      if (can == 0) {
        this.dialogVisible2 = false;
        this.unSubmit = true;
      }
    },
    /*发送手机验证*/
    getCode() {
      let that = this;
      if (this.second < 120) {
        return
      }
      if (that.flag) {
        sendsms({mobile: that.mediaForm.phone, name: "申请认证", uid: that.userInfo.cid, uuid: '帮企网'}).then(res => {
          if (res.code == 200) {
            this.$message.success('验证码已发送');
            that.flag = false;
            let interval = setInterval(() => {
              if (that.second <= 0) {
                clearInterval(interval);
                this.second = 120;
                that.flag = true;
                return
              } else {
                this.second--
              }
            }, 1000)
          }
        })
      }
    },
    /*隐私政策*/
    privacyPolicy() {
      window.open('https://customerservice.bangqichat.com/index/agreement/article?aWQ9MjA=', '_blank')
    },
    submitForm(){
      let that = this;
      let can = 0;
      for (let a = 0; a < 3; a++) {
        that.$refs['mediaForm' + a].validate((valid) => {
          if (valid) {
          } else {
            can++;
            return false;
          }
        });
      }
      if (can==0){
        if (that.unSubmit) {
          verifySms({smscode: that.mediaForm.code, uuid: that.mediaForm.phone, uid: that.userInfo.cid}).then(res=>{
            if (res.code==200){
              let cityName='';
              for (let list of that.areaInfo){
                if (list.value==that.operationForm.address[0]){
                  cityName=list.label;
                  for (let sub of list.children){
                    if (sub.value==that.operationForm.address[1]){
                      cityName+='-'+list.label;
                      for (let children of list.children) {
                        if (children.value == that.operationForm.address[2]) {
                          cityName += '-' + children.label;
                        }
                      }
                    }
                  }
                }
              }
              let formData={
                bqwCertificationEightVO: {
                  verifiedType: 4,
                  institutionName: that.mediaForm.institutionName,
                  abbreviation: "",
                  socialCreditCode: that.mediaForm.creditCode,
                  avatar: that.mediaForm.avatar,
                  summary: "",
                  locationCity: cityName,
                  contactAddress: that.corporateInfo.address,
                  cityCode: that.mediaForm.address[0],
                  areaCode: that.mediaForm.address[1],
                  districtCode: that.mediaForm.address[2],
                  identityimgBack: that.mediaForm.identityimgBack,
                  identityimgFront: that.mediaForm.identityimgFront,
                  phone: that.mediaForm.phone,
                  code: that.mediaForm.code,
                  id: 0,
                  microWebsiteStatus: 0,
                  certificationProofList: [
                    {
                      proofType: 7,
                      proofUrl: that.mediaForm.proofUrl
                    }
                  ],
                  chooseMicroWebsite: 1,
                  cid: that.userInfo.cid,
                  legalPerson:that.corporateInfo.fname
                },
                uid: that.userInfo.cid
              }
              reviewAuthenticationForEight(formData).then(res => {
                if (res.code == 200) {
                  that.$alert('媒体认证信息提交成功，正在审核，请耐心等待。', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      window.location.reload()
                    }
                  });
                }
              })
            }else{
              that.$message.success('短信验证失败，请填写正确的验证码。');
            }
          })
        } else {
          that.dialogVisible2 = true
        }
      }
    }
  },
  mounted() {
    this.getBusinessType();
  },
  beforeMount() {
    this.userInfo = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')) : {};
    this.mediaForm.avatar = this.userInfo.user_avatar;
  },
  beforeDestroy() {
    clearInterval(this.second);
    this.second = null;
  },
}
</script>
<style scoped>
.media-authentication-container >>> .media-authentication-content .el-form--label-top .el-form-item__label {
  padding: 0 0 0px;
}
.media-authentication-container >>> .media-authentication-content .upload-image .el-upload {
  border: 1px solid #F2F2F2;
  background: #F2F2F2;
  border-radius: 6px;
  width: 100px;
  height: 100px;
  line-height: 100px;
  font-size: 25px;
  color: #666;
}
.media-authentication-container >>> .media-authentication-content .upload-avatar .el-upload {
  border: 1px solid #F2F2F2;
  background: #F2F2F2;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  line-height: 100px;
  font-size: 25px;
  color: #666;
}
.media-authentication-container >>> .media-authentication-content .el-upload__tip {
  font-size: 14px;
  color: #333333;
  margin-top: 0px;
}
.media-authentication-container >>> .media-authentication-content .el-cascader {
  width: 100%;
}
.media-authentication-container >>> .media-authentication-content .el-checkbox__label {
  display: inline-flex;
  font-size: 14px;
  color: #333333;
}
.media-authentication-container >>> .media-authentication-content .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  width: 30%;
  padding: 15px;
}
.media-authentication-container >>> .media-dialog .el-dialog__body {
  padding: 0px 0px;
  color: #333333;
  font-size: 20px;
}
.media-authentication-container >>> .media-dialog .el-dialog__header {
  padding: 0px;
  display: none;
}

.media-authentication-container >>> .media-dialog .el-col-6 {
  width: 30%;
  font-weight: bold;
}

.media-authentication-container >>> .media-dialog .el-col-15 {
  width: 60%;
}

.media-authentication-container >>> .media-dialog .el-dialog {
  margin: 0 auto 0px;
}

.media-authentication-container >>> .supplementInfo .el-form--inline {
  display: flex;
  justify-content: space-between;
}

.media-authentication-container >>> .supplementInfo .el-form--inline .el-form-item {
  margin-right: 0px;
}


.media-authentication-container >>> .supplementInfo input::-webkit-input-placeholder,
.media-authentication-container >>> .supplementInfo textarea::-webkit-input-placeholder {
  font-size: 14px;
  color: #ABABAB;
  font-family: 'SourceHanSansCN';
  font-weight: 100;
}

.media-authentication-container >>> .supplementInfo .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-weight: bold;
  color: #5D5D5D;
}

.media-authentication-container >>> .supplementInfo .price-icon {
  font-style: normal;
  padding-right: 5px;
  color: #333333;
}

.media-authentication-container >>> .el-form-item__label {
  font-size: 14px;
  color: #333333;
}

.media-authentication-container >>> .supplementInfo .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  width: auto;
  padding: 12px 20px;
}
.media-authentication-container >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.media-authentication-container >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #1637FF;
  border-color: #1637FF;
}
</style>
<style scoped lang="scss">
.media-authentication-container {
  .media-authentication-content {
    .tips {
      margin-block-end: 0px;
      margin-block-start: 0px;
      font-size: 14px;
      color: #666666;
    }

    .small-title {
      margin-block-end: 20px;
      margin-block-start: 20px;
      font-size: 16px;
      font-family: 'SourceHanSansCN';
      color: #333333;
    }
    .el-active {
      color: #1637FF;
    }

    .gary-tips {
      margin-block-start: 0px;
      margin-block-end: 0px;
      color: #999999;
      font-size: 14px;
    }

    .certificate {
      width: 100px;
      height: 100px;
      border-radius: 6px;
      background: url("~@/assets/img/enterprise/digitalBusinessCertificate1.png") no-repeat;
      background-size: 100% 100%;
    }

    .certificate-dialog {
      width: 790.02px;
      height: 914.76px;
      background: url("~@/assets/img/enterprise/digitalBusinessCertificate.png") no-repeat;
      background-size: 100% 100%;

      .dialog-content {
        padding-top: 320px;
        padding-left: 120px;
      }

      .dialog-row {
        font-size: 20px;
        color: #333333;
        font-family: "SourceHanSansCN";
        line-height: 50px;
      }
    }
  }
}
</style>